export enum Reason {
  closeBtn = 0,
  submitBtn = 1
}
